import type { ReactNode } from 'react';

export const symbol_domain_verification_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m812-63-98-97H140q-24.75 0-42.37-17.63Q80-195.25 80-220v-520q0-24.75 17.63-42.38Q115.25-800 140-800h20v86L47-827q-9-9.07-8.5-21.53Q39-861 48.05-870q9.06-9 21.5-9Q82-879 91-870l764 765q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q821-54 812-63ZM140-220h514L218-656h-78v436Zm446-240-44-44 42-42q9.13-9 22.07-9 12.93 0 21.93 9.1 9 9.11 9 22 0 12.9-9 21.9l-42 42Zm-43 43-84 84q-9 9-21 9t-21-9l-85-85q-9-9.13-9-22.07 0-12.93 9.1-21.93 9.11-9 22-9 12.9 0 21.9 9l62 62 61-61 44 44Zm337-323v512q0 15-9.32 22.5t-20.5 7.5q-11.18 0-20.68-7.68-9.5-7.69-9.5-22.32v-428H415q-12.44 0-23.72-5T372-674l-75-75q-6.92-7.81-8.46-16.41Q287-774 290-782t10.5-13q7.5-5 17.5-5h502q24.75 0 42.38 17.62Q880-764.75 880-740Z"
		/>
	</svg>
);
